module.exports = __webpack_public_path__ + "static/media/code_1.eddf5172.jpg";